import {map} from 'rxjs/operators';

import {MatDialog} from '@angular/material/dialog';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiServiceService} from '../../../api-service.service';
import {Keys, StorageService} from '../../../service/storage.service';
import {NopassbookComponent} from '../../../nopassbook/nopassbook.component';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-borrower-menu',
    templateUrl: './borrower-menu.component.html',
    styleUrls: ['./borrower-menu.component.css']
})
export class BorrowerMenuComponent implements OnInit {

    passbookLink: any;
    dashboardLink: any;
    documentsLink: any;
    referralsLink: any;
    kycSuccess: boolean;
    passbookClass: string;
    dashboardClass: string;
    documentsClass: string;
    referralsClass: string;
    loan_sanction_status: string;

    constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private ref: ApiServiceService,
                private storageService: StorageService, public dialog: MatDialog) {
    }

    blockPassbook() {
        this.dialog.open(NopassbookComponent, {height: '180px', width: '400px'});
    }

    ngOnInit() {
        this.http.post<any>(this.ref.baseURL() + 'getLoanInfoDetails', {
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            loan_id: this.storageService.getItem(Keys.LOAN_ID),
            token: this.storageService.getItem(Keys.TOKEN)
        }).subscribe((result) => {
                if (result.status == 'success') {
                    if (this.route.snapshot.url[0].path == 'passbook') {
                        this.passbookClass = '-active';
                    } else if (this.route.snapshot.url[0].path == 'referrals') {
                        this.referralsClass = '-active';
                    } else if (this.route.snapshot.url[0].path == 'documents') {
                        this.documentsClass = '-active';
                    } else if (this.route.snapshot.url[0].path == 'loansanction' || this.route.snapshot.url[0].path == 'loanprogress' ||
                        this.route.snapshot.url[0].path == 'borrowerdashboard' || this.route.snapshot.url[0].path == 'loan-matured') {
                        this.dashboardClass = '-active';
                    }

                    /*-------------------------------------------------------------------------------------------------------------------*/

                    this.loan_sanction_status = result.loan_info.loan_sanction_status;
                    if (this.loan_sanction_status == 'pending' || this.loan_sanction_status == 'ready_for_kyc' ||
                        this.loan_sanction_status == 'kyc_in_progress' || this.loan_sanction_status == 'ready_for_pcd' ||
                        this.loan_sanction_status == 'pcd_in_progress' || this.loan_sanction_status == 'ready_for_dcd' ||
                        this.loan_sanction_status == 'dcd_in_progress' || this.loan_sanction_status == 'sanctioned' ||
                        this.loan_sanction_status == 'loan_expired' || this.loan_sanction_status == 'bank_details_filled' ||
                        this.loan_sanction_status == 'rejected' || this.loan_sanction_status == 'closed' || this.loan_sanction_status == 'closed_prepayment') {
                        this.kycSuccess = false;
                        this.dashboardLink = ['/loansanction'];
                        this.passbookLink = ['/passbook'];
                        this.documentsLink = ['/documents'];
                        this.referralsLink = ['/referrals'];
                    } else if (this.loan_sanction_status == 'accepted' || this.loan_sanction_status == 'loan_fulfilled' ||
                        this.loan_sanction_status == 'document_collected' || this.loan_sanction_status == 'document_verified' ||
                        this.loan_sanction_status == 'queued_to_be_fulfilled' || this.loan_sanction_status == 'ready_for_disbursal' ||
                        this.loan_sanction_status == 'loan_disbursed_initiated') {
                        this.kycSuccess = true;
                        this.dashboardLink = ['/loanprogress'];
                        this.passbookLink = ['/passbook'];
                        this.documentsLink = ['/documents'];
                        this.referralsLink = ['/referrals'];
                    } else if (this.loan_sanction_status == 'document_hardcopy_recieved'
                        || this.loan_sanction_status == 'loan_disbursed' || this.loan_sanction_status == 'sub_standard_asset' || this.loan_sanction_status == 'loss_asset') {
                        this.kycSuccess = true;
                        this.dashboardLink = ['/borrowerdashboard'];
                        this.passbookLink = ['/passbook'];
                        this.documentsLink = ['/documents'];
                        this.referralsLink = ['/referrals'];
                    } else if (this.loan_sanction_status == 'loan_matured') {
                        this.kycSuccess = true;
                        this.dashboardLink = ['/loan-matured'];
                        this.passbookLink = ['/passbook'];
                        this.documentsLink = ['/documents'];
                        this.referralsLink = ['/referrals'];
                    }
                }
            });
    }

}
